import { IntlShape } from 'react-intl';

import { loanMessages } from '@app/translations';
import { ItemStatusData } from '@app/constants';

interface ChargesData {
  intl: IntlShape;
  isNonCatalogItem?: boolean;
  chargeAmount?: { amount?: number; isoCurrencyCode?: string };
}

export const getChargesData = ({
  intl,
  chargeAmount: { amount, isoCurrencyCode } = {},
  isNonCatalogItem = false,
}: ChargesData): Partial<ItemStatusData> => {
  const feesValue =
    (amount !== undefined &&
      isoCurrencyCode &&
      intl.formatNumber(amount, {
        style: 'currency',
        currency: isoCurrencyCode,
      })) ||
    '';
  const feesTitle = intl.$t(
    isNonCatalogItem ? loanMessages.amount : loanMessages.fees
  );

  return {
    feesTitle,
    feesValue,
  };
};
